import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listInvestments } from '../../../redux/actions/investments';
import { createNotify } from '../../../redux/actions/notify';
import showNotification from '../../global/Notification/showNotification';
import Button from '../../global/form/Button/Button';
import './CreateNotifyModal.scss';

const CreateNotifyModal = ({ showNotifyModal, handleShowModal, dataNotify }) => {
  const dispatch = useDispatch();
  const notify = useSelector(state => state.notify)

  const handleNotify = () => {
    const payload = {
      title: dataNotify.name,
      type: "EVALUATION_REMINDER",
      units: dataNotify.units,
      roles: dataNotify.roles
    }

    dispatch(createNotify(payload)).then(() => {
      showNotification('Investimento criado com sucesso!', 5000);
      handleShowModal(false)
      dispatch(listInvestments())
    }).catch(() => showNotification('Houve um erro inesperado, tente mais tarde!', 5000))
  }

  return (
    <div className={`CreateNotifyModal ${showNotifyModal ? "active" : ""}`}>
      <div className="container-create">
        <div className='container-title'>
          <p>Competência adicionada com sucesso!</p>
          <p>Deseja notificar comunidade?</p>
        </div>

        <div className="container-buttons">
          {notify.isFetching ? <p>Carregando</p> :
            <>
              <Button onClick={() => handleNotify()}>SIM</Button>
              <Button onClick={() => {
                handleShowModal()
                dispatch(listInvestments())
                showNotification('Investimento criado com sucesso!', 5000);
              }}>NÃO</Button>
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default CreateNotifyModal
